import { isEqual, isNil } from "lodash";
import LZString from "lz-string";
import {
  decodeJson,
  encodeJson,
  type QueryParamConfig,
} from "serialize-query-params";

export const CustomJsonParam = <T>(): QueryParamConfig<T> => ({
  encode: (value) => encodeJson(value),
  decode: (value) => decodeJson(value),
  equals: (a, b) => isEqual(a, b),
});

export const CustomJsonCompressedParam = <T>(): QueryParamConfig<T> => ({
  encode: (value) => {
    const stringified = encodeJson(value);
    if (isNil(stringified)) {
      return stringified;
    }

    const compressed = LZString.compressToEncodedURIComponent(stringified);
    return compressed;
  },
  decode: (value) => {
    if (isNil(value)) {
      return value;
    }
    return decodeJson(
      LZString.decompressFromEncodedURIComponent(value as string),
    );
  },
  equals: (a, b) => isEqual(a, b),
});
